import { IAppState } from '../../../AppModulesWrapper';

export function selectIsInsufficientFunds(state: IAppState): boolean {
  return !!state.servicePickerWidget.checkoutInfo.isInsufficientFunds;
}
